export interface SeoData {
  title?: string;
  description?: string;
  keywords?: string;
  canonical?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  ogUrl?: string;
  ogImage?: string | null;
  twitterCard?: string;
  twitterTitle?: string;
  twitterDescription?: string;
  twitterImage?: string | null;
}

const SITE_URL: string =
  (import.meta.env.VITE_SITE_URL as string | undefined) || 'https://allchinabuyspread.autos';

export const FAVICON_URL =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/49750b7389edabeda6497a215e0702e5.png';

export const SITE_NAME = 'AllChinaBuy Spreadsheet';

export const HOME_TITLE = 'AllChinaBuy Spreadsheet 2026: Guides, Sellers, Shipping & Reviews';
export const HOME_DESCRIPTION =
  'Explore the AllChinaBuy Spreadsheet with practical buying guides, seller resources, QC tips, shipping information, reviews, coupons and safety advice.';
export const HOME_KEYWORDS =
  'AllChinaBuy Spreadsheet, AllChinaBuy review, AllChinaBuy shipping, AllChinaBuy guide, AllChinaBuy sellers, AllChinaBuy QC';

export function getSiteUrl(): string {
  return SITE_URL.replace(/\/+$/, '');
}

function upsertMeta(attr: 'name' | 'property', key: string, content: string | null | undefined): void {
  const el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!content) {
    if (el) el.remove();
    return;
  }
  if (el) {
    el.setAttribute('content', content);
  } else {
    const meta = document.createElement('meta');
    meta.setAttribute(attr, key);
    meta.setAttribute('content', content);
    document.head.appendChild(meta);
  }
}

function upsertCanonical(href: string | null | undefined): void {
  const el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!href) {
    if (el) el.remove();
    return;
  }
  if (el) {
    el.setAttribute('href', href);
  } else {
    const link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', href);
    document.head.appendChild(link);
  }
}

export function applySeo(data: SeoData): void {
  if (data.title) document.title = data.title;
  upsertMeta('name', 'description', data.description);
  upsertMeta('name', 'keywords', data.keywords);
  upsertCanonical(data.canonical);
  upsertMeta('property', 'og:title', data.ogTitle);
  upsertMeta('property', 'og:description', data.ogDescription);
  upsertMeta('property', 'og:type', data.ogType);
  upsertMeta('property', 'og:url', data.ogUrl);
  upsertMeta('property', 'og:image', data.ogImage);
  upsertMeta('name', 'twitter:card', data.twitterCard);
  upsertMeta('name', 'twitter:title', data.twitterTitle);
  upsertMeta('name', 'twitter:description', data.twitterDescription);
  upsertMeta('name', 'twitter:image', data.twitterImage);
}

export function setNoindex(enable: boolean): void {
  const el = document.head.querySelector<HTMLMetaElement>('meta[name="robots"]');
  if (enable) {
    if (el) {
      el.setAttribute('content', 'noindex, nofollow');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('name', 'robots');
      meta.setAttribute('content', 'noindex, nofollow');
      document.head.appendChild(meta);
    }
  } else if (el) {
    el.remove();
  }
}

export function buildHomeSeo(): SeoData {
  const site = getSiteUrl();
  return {
    title: HOME_TITLE,
    description: HOME_DESCRIPTION,
    keywords: HOME_KEYWORDS,
    canonical: `${site}/`,
    ogTitle: HOME_TITLE,
    ogDescription: HOME_DESCRIPTION,
    ogType: 'website',
    ogUrl: `${site}/`,
    ogImage: null,
    twitterCard: 'summary_large_image',
    twitterTitle: HOME_TITLE,
    twitterDescription: HOME_DESCRIPTION,
    twitterImage: null,
  };
}